import React from 'react';
import { Column, ColumnContainer, LoadingContainer, SectionTitle, TitleContainer } from '@beacharound/beacharound-ui';

import ProductItem from './ProductItem';

export default function UmbrellasList({ data, isLoading, daysNum, hidePrice }) {

    return (
        <LoadingContainer isLoading={isLoading}>
            {data?.length > 0 &&
                <ColumnContainer lowMargin>
                    <Column>
                        <TitleContainer lowMargin>
                            <SectionTitle text="Ombrelloni" />
                        </TitleContainer>
                        {data?.sort((a, b) => a.price - b.price).map((item, index) =>
                            <ProductItem
                                key={index}
                                item={item}
                                daysNum={daysNum}
                                hidePrice={hidePrice}
                            />
                        )}
                    </Column>
                </ColumnContainer>
            }
        </LoadingContainer>
    );
}